var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// React
import React from 'react';
// Hook
import { useField } from '../../hook/field.hook';
import { useVisibility } from '../../hook/visibility.hook';
// Core method
import { getGroupFilteredFieldOptions } from './form.core';
// Components
import { useOptions } from '../../hook/options.hook';
import Form from '../Form';
var FormBuilder = function (props) {
    var _a = useVisibility(), setVisibleFieldList = _a.setVisibleFieldList, visibleFieldList = _a.visibleFieldList;
    var setOptions = useOptions().setOptions;
    var dataSchemaJson = props.dataSchemaJson, uiSchemaJson = props.uiSchemaJson, Components = props.Components, groupProps = props.groupProps, linkedFieldList = props.linkedFieldList;
    var _b = React.useState(props.formHandler.initialValues), values = _b[0], setValues = _b[1];
    var resetField = useField().resetField;
    React.useEffect(function () {
        setValues(props.formHandler.initialValues);
    }, [props.formHandler.initialValues]);
    // Visibility effect
    React.useEffect(function () {
        /**
         * Get visible fields
         * @param formValues
         */
        var getVisibleFields = function (formValues) {
            return groupProps.childrenProps.map(function (group) {
                return getFilteredFieldList(group.childrenProps, formValues)
                    .map(function (field) { return field.name; });
            })
                .reduce(function (previousValue, nextValue) { return __spreadArrays(previousValue, nextValue); }, []);
        };
        setVisibleFieldList(getVisibleFields(values));
    }, [setVisibleFieldList, values, groupProps.childrenProps]);
    React.useEffect(function () {
        var getFieldOptions = function (formValues) {
            return groupProps.childrenProps
                .map(function (group) {
                return getGroupFilteredFieldOptions(group.childrenProps, formValues);
            })
                .reduce(function (previousFieldsOptions, currentFieldOptions) { return (__assign(__assign({}, previousFieldsOptions), currentFieldOptions)); }, {});
        };
        setOptions(getFieldOptions(values));
    }, [values, groupProps.childrenProps, setOptions]);
    var display = {
        assetUrl: uiSchemaJson.assetsUrl,
        description: dataSchemaJson.description,
        stepper: props.stepper,
        title: dataSchemaJson.title,
    };
    var data = {
        groupList: groupProps.childrenProps,
        initialValues: props.formHandler.initialValues
    };
    /**
     * Get field filtered by visibility
     * @param fieldList
     * @param fieldsValues
     */
    var getFilteredFieldList = function (fieldList, fieldsValues) { return fieldList.filter(function (field) {
        return field.getFieldVisibility ? field.getFieldVisibility(fieldsValues) : true;
    }); };
    /** Reset all values of fields linked to field param */
    var resetLinkedField = function (fieldName) {
        var fieldNameList = Object.keys(linkedFieldList);
        var fieldToReset = fieldNameList.filter(function (targetField) { return linkedFieldList[targetField].includes(fieldName); });
        if (fieldToReset.length) {
            return fieldToReset.map(function (field) {
                var _a;
                resetField(field);
                var children = resetLinkedField(field);
                return __assign((_a = {}, _a[field] = Array.isArray(values[field]) ? [] : '', _a), children);
            }).reduce(function (prev, curr) { return (__assign(__assign({}, prev), curr)); }, {});
        }
    };
    var formHandlerHandleChange = function (eventType) {
        var _a, _b;
        var others = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            others[_i - 1] = arguments[_i];
        }
        var newValues;
        var fieldName;
        if (eventType === 'keyValue') {
            var _c = others[0], key = _c[0], value = _c[1];
            fieldName = key;
            newValues = __assign(__assign({}, values), (_a = {}, _a[fieldName] = value, _a));
            props.updateValue(fieldName, value);
            props.formHandler.setFieldValue(fieldName, value);
        }
        else {
            others[0].persist();
            fieldName = others[0].target.name;
            newValues = __assign(__assign({}, values), (_b = {}, _b[fieldName] = others[0].target.value, _b));
            props.updateValue(fieldName, others[0].target.value);
            props.formHandler.handleChange(others[0]);
        }
        var fieldToReset = resetLinkedField(fieldName);
        setValues(__assign(__assign({}, newValues), fieldToReset));
    };
    var formHandler = {
        errors: props.formHandler.errors,
        handleBlur: props.formHandler.handleBlur,
        handleChange: formHandlerHandleChange,
        handleGroupValidity: function (validationData) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkGroupValidity(validationData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        handleSubmit: function (submitData) {
            props.formHandler.handleSubmit(submitData);
        },
        touched: props.formHandler.touched,
    };
    /**
     * Check group validity
     * @param groupIndex
     */
    var checkGroupValidity = function (groupIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var fieldList, fieldListName, validation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fieldList = data.groupList[groupIndex].childrenProps;
                    fieldListName = fieldList.map(function (field) { return field.name; });
                    return [4 /*yield*/, props.formHandler.validateForm()];
                case 1:
                    validation = _a.sent();
                    try {
                        return [2 /*return*/, fieldListName.map(function (fieldName) {
                                props.formHandler.setFieldTouched(fieldName, true);
                                props.formHandler.setFieldError(fieldName, validation[fieldName]);
                                return !validation[fieldName];
                            }).reduce(function (previousValue, currentValue) { return previousValue && currentValue; })];
                    }
                    catch (error) {
                        console.error(error);
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (!visibleFieldList.length) {
        return null;
    }
    return React.createElement(React.Fragment, null,
        React.createElement(Form, { display: display, Components: Components, data: data, formHandler: formHandler }));
};
export default FormBuilder;
//# sourceMappingURL=index.js.map